import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, Modal, Row, Switch } from "antd";
import React from "react";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import { validations } from "../../../../config/validations/validations";
import SVGIcon from "../../../../utils/SVGIcon";

const FormComponent: React.FC<any> = (props) => {
  const { visible, title, close, form, handleSubmit, check, setCheck, type } =
    props;

  const handleChange = () => {
    form.validateFields();
  };
  const resetField = () => {
    form.resetFields();
  };

  return (
    <Modal
      open={visible}
      destroyOnClose
      width={900}
      onCancel={close}
      closeIcon={<FontAwesomeIcon icon={faTimes} />}
      footer={false}
      className="addModal"
      title={title}
    >
      <FormBox
        className="filterForm"
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={["onBlur", "onInput"]}
        autoComplete="off"
      >
        <Row gutter={30} align={"top"}>
          <Col xs={24} md={12}>
            <InputBox.Text
              name="number"
              label="Number"
              required
              maxLength={10}
              rules={[validations.pattern.numeric, validations.required.text()]}
            />
          </Col>
          <Col xs={24} md={12}>
            <InputBox.Text
              name="icicid"
              label="ICC ID"
              maxLength={10}
              rules={[
                validations.pattern.numeric,
                validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={24} md={12}>
            <InputBox.Text
              name="price"
              label="Price"
              step="0.00"
              maxLength={10}
              rules={[
                validations.pattern.decimal(2),
                validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={24} md={12}>
            <InputBox.Text
              name="gb"
              label="GB"
              maxLength={10}
              rules={[
                validations.pattern.numeric,
                validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={24} md={12}>
            <InputBox.Text
              name="call"
              label="Call"
              maxLength={10}
              rules={[
                validations.pattern.numeric,
                validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={24} md={12}>
            <InputBox.Text
              name="sms"
              label="SMS"
              maxLength={10}
              rules={[
                validations.pattern.numeric,
                validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={24} md={12}>
            <InputBox.Text
              name="name"
              label="Name"
              rules={[
                validations.pattern.whitespace,
                validations.min.text(3),
                validations.max.text(50),
              ]}
            />
          </Col>
          <Col xs={24} md={12}>
            <Form.Item label="Status" valuePropName="checked" name="status">
              <Switch defaultChecked={check} onChange={(e) => setCheck(e)} />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <InputBox.TextArea
              name="description"
              label="Description"
              placeholder="Description"
              rows={2}
              rules={[
                validations.pattern.whitespace,
                validations.min.text(3),
                validations.max.text(100),
              ]}
            />
          </Col>
        </Row>
        <Row gutter={30} align={"top"}>
          <Col xs={24} md={12} lg={6}>
            <Button type="primary" htmlType="submit">
              {" "}
              {type === "Edit" ? (
                "Update"
              ) : (
                <>
                  <SVGIcon icon="add" color="#fff" width={55} />
                  Add
                </>
              )}
            </Button>
          </Col>
          <Col xs={24} md={12} lg={6}>
            <Button type="default" onClick={() => resetField()}>
              Clear
            </Button>
          </Col>
        </Row>
      </FormBox>
    </Modal>
  );
};

export default FormComponent;
